import { v4 as uuidv4 } from "uuid";
import { getColorOptions } from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as StatCardDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sections/StatCardBlock/StatCardBlockDefaultData";
import {
  createH3Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const createStatCardBlock = ({
  number,
  text,
  baseData = StatCardDefaultData,
  value = [],
  styles = {},
}: {
  number?: string;
  text?: string;
  baseData?: BaseBlock;
  value?: BaseBlock[];
  styles?: Record<string, StyleValue>;
}): BaseBlock => ({
  ...baseData,
  id: uuidv4(),
  props: {
    ...baseData.props,
    content: {
      ...baseData.props.content,
      type: "children",
      prop: "children",
      value:
        value && value.length > 0
          ? value
          : [
              createH3Block({
                text: number || "",
                styles: {
                  color: getColorOptions(
                    "var(--theme-website-color-text-secondary)",
                  ),
                },
              }),
              createPBlock({
                text: text || "",
              }),
            ],
    },
    styles: {
      ...baseData.props?.styles,
      prop: "styles",
      type: "styles",
      value: {
        ...(baseData.props?.styles?.value as Record<string, StyleValue>),
        ...styles,
      },
    },
  },
});
